module.exports = __webpack_public_path__ + "img/BlueClear.287e77fa.jpg";